module.exports = __webpack_public_path__ + "assets/img/106.93bfb873.png";